import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * The thin progress bar shown while a scanner waits for the AI response.
 * Pure display: the page (or the analyzing overlay) drives `progress`
 * from the shared asymptotic fake-progress curve.
 */
@Component({
  selector: 'cs-scanner-progress-bar',
  templateUrl: 'cs-scanner-progress-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CsScannerProgressBarComponent {
  /** Fill percentage, 0-100. */
  @Input() progress = 0;
}
